import { FC, InputHTMLAttributes } from "react"
import "./styles.scss"

export const Switch: FC<InputHTMLAttributes<HTMLInputElement>> = ({
  ...rest
}) => {
  return (
    <label className="switch">
      <input type="checkbox" {...rest} />
      <span className="slider round"></span>
    </label>
  )
}
